import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  background: 'linear-gradient(180deg, #3D9FDD 0%, #268CCD 100%)',
  alignItems: 'center',
  gap: {
    xs: '2.4rem',
    lg: '4.8rem',
  },
  padding: {
    xs: '3.2rem 2.4rem',
    md: '4rem 2.4rem',
    lg: '8rem',
  },
}

export const contentSx: SxProps<Theme> = {
  maxWidth: {
    xs: '100%',
    lg: '103%',
    xl: '102%',
  },
}

export const titleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.contrastText,
}

export const circularProgressSx: SxProps<Theme> = {
  display: 'flex',
  height: '100% !important',
  color: (theme) => theme.palette.primary.contrastText,
}

export const carouselItemsWrapperSx: SxProps<Theme> = {
  gap: {
    xs: '0.8rem',
    md: '2.4rem',
  },
  width: '100%',
  maxWidth: {
    lg: '125.6rem',
    xl: '165rem',
  },
}

export const carouselArrowWrapperSx: SxProps<Theme> = {
  marginTop: {
    xs: '-1.4rem',
    md: '-2.2rem',
  },
  width: {
    xs: '3.2rem',
    md: '4.8rem',
  },
  height: {
    xs: '3.2rem',
    md: '4.8rem',
  },
}

export const carouselLeftArrowWrapperSx: SxProps<Theme> = {
  ...carouselArrowWrapperSx,
  marginLeft: '-1rem',
}

export const carouselRightArrowWrapperSx: SxProps<Theme> = {
  ...carouselArrowWrapperSx,
  marginRight: '-1rem',
}
